import React from "react"
import {Button} from "@mui/material"

import {RevokeOfferModal} from "./RevokeOfferModal"

import {colors} from "@indebted/theme/colors"
import {CustomerOffer, RevocationReason} from "@indebted/api"
import {getOfferStatus} from "@indebted/api/customerOffersAPI"

type RemoveOfferButtonProps = {
	offer: CustomerOffer
	revocationReasons: RevocationReason[]
}

function RemoveOfferButton({offer, revocationReasons}: RemoveOfferButtonProps) {
	const [modalOpen, setModalOpen] = React.useState(false)

	const status = getOfferStatus(offer)
	if (status !== "available" && status !== "upcoming") return null

	const handleSuccess = () => {
		setModalOpen(false)
	}

	return (
		<>
			<Button
				variant="contained"
				size="small"
				onClick={() => setModalOpen(true)}
				sx={{
					backgroundColor: colors.error["600"],
					"&:hover": {backgroundColor: colors.error["700"]},
					textTransform: "uppercase",
					fontWeight: 500,
					letterSpacing: "0.4px",
					borderRadius: "4px",
					whiteSpace: "nowrap",
				}}
			>
				Remove Offer
			</Button>
			{modalOpen && (
				<RevokeOfferModal
					offerID={offer.OfferID}
					open={modalOpen}
					onClose={() => setModalOpen(false)}
					onSuccess={handleSuccess}
					revocationReasons={revocationReasons}
				/>
			)}
		</>
	)
}

export {RemoveOfferButton}
